import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Rocket01 = function Rocket01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12.9996 10.9999-9.5 9.5M14.0181 3.5384c1.218.8082 2.3887 1.761 3.4827 2.855 1.1034 1.1034 2.0632 2.285 2.8759 3.5143M9.2546 7.896l-2.8749-.9582a1 1 0 0 0-.9621.1853L2.5604 9.5406c-.585.495-.4187 1.4369.3002 1.7018l2.7072.9974m6.1129 6.1126.9974 2.7072c.2649.719 1.2068.8852 1.7017.3003l2.4176-2.8572a1 1 0 0 0 .1853-.9622l-.9583-2.8748m3.3238-12.395-4.9064.8177a2.443 2.443 0 0 0-1.3827.741l-6.6131 7.069c-1.7141 1.8323-1.6665 4.6939.1078 6.4682 1.7742 1.7742 4.6358 1.8219 6.4682.1077l7.0691-6.613a2.443 2.443 0 0 0 .741-1.3827l.8177-4.9065c.2256-1.3536-.9479-2.5272-2.3016-2.3016"
    })
  }));
};
export default Rocket01;